import { inspect } from 'util';
import { pick } from 'lodash-es';
export function parseError(error) {
    if (error instanceof Error) {
        return pick(error, Object.getOwnPropertyNames(error));
    } else {
        return {
            message: inspect(error)
        };
    }
}
export function stringifyError(error) {
    return JSON.stringify(parseError(error));
}
